<template>
  <div class="a4 mb-4">
    fatura önizleme
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
export default {
  name: 'InvoiceWaybillPage',
  data () {
    return { }
  },
  methods: {

  },
  mounted() {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  @media screen {
    body {
      margin-top: 60px !important;
      background: #FFF !important;
    }

    div.a4 {
      margin-top: 20px !important;
      width: 21cm;
      height: 29.7cm;
      margin: 0 auto;
      -webkit-box-shadow: 0px 5px 10px -2px rgba(204,204,204,1);
      -moz-box-shadow: 0px 5px 10px -2px rgba(204,204,204,1);
      box-shadow: 0px 5px 10px -2px rgba(204,204,204,1);
      border: 1px solid #D0D0D0;
    }
  }

  @media print {

    * {-webkit-print-color-adjust:exact;}

    body {
      background-color: aqua;
      width: 21cm !important;
      height: 29.7cm !important;
      margin: 0 !important;
      padding-top: 0px !important;
    }

    div.a4 {
      display: none;
      margin-top: 0 !important;
      width: 100% !important;
      height: 100% !important;
      background-color: blue !important;
    }

    #headerNavBar {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/InvoiceWaybillPage.vue